import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const GeneralNpsPage = React.lazy(() => import('modules/nps/pages/GeneralNpsPage'))
const ProductNpsPage = React.lazy(() => import('modules/nps/pages/ProductNpsPage'))
const RootPage = React.lazy(() => import('modules/nps/pages/RootPage'))

export const npsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.nps.path,
      element: <RootPage />,
      handle: {
        module: 'nps',
      },
      children: [
        {
          index: true,
          element: <GeneralNpsPage />,
        },
        {
          path: navigation.nps.item.path,
          element: <ProductNpsPage />,
        },
      ],
    },
  ]
}
